import i18n from './i18n';

export const SUPPORTED_MIMETYPES = [
  'video/mp4',
  'video/mpeg',
  'video/webm',
  'video/x-msvideo',
  'video/x-matroska',
  'audio/webm',
  'audio/mp3',
  'audio/mpeg',
  'audio/ogg',
  'audio/opus',
  'audio/wav',
  'audio/wave',
  'audio/x-m4a',
  'audio/m4a',
  'audio/mp4a-latm',
  'audio/x-wav',
  'audio/mp4',
  'audio/mpeg',
  'audio/x-ms-wma',
  'video/quicktime',
  'audio/aiff',
  'audio/x-aiff',
  'audio/aac',
  'audio/x-aac',
  'audio/x-hx-aac-adts',
];

export const SUPPORTED_EXTENSIONS = [
  'mp4',
  'mpeg',
  'webm',
  'avi',
  'mkv',
  'webm',
  'mp3',
  'ogg',
  'opus',
  'wav',
  'm4a',
  'mp4a',
];

export const SUGGESTED_EDITS_THRESHOLD = 0.4;
export const PREVALENCE_THRESHOLD = 0.01;

export const NAME_SUGGESTION_THRESHOLD = 0.5;

export const SOURCES = {
  file: i18n.t('Fil'),
  url: i18n.t('Youtube'),
  youtube: i18n.t('Youtube'),
  record: i18n.t('Diktafon'),
  phone: i18n.t('Telefon'),
  google: i18n.t('Google Meet'),
  zoom: i18n.t('Zoom'),
  teams: i18n.t('Teams'),
  compodium: i18n.t('Compodium'),
  other: i18n.t('Annan'),
};

export const MEETING_SOURCES = [
  'google',
  'zoom',
  'teams',
];

export const TRANSLATION_LANGUAGES = {
  swe: i18n.t('Svenska'),
  eng: i18n.t('Engelska'),
  dan: i18n.t('Danska'),
  nob: i18n.t('Norska (Bokmål)'),
  deu: i18n.t('Tyska'),
  fra: i18n.t('Franska'),
  spa: i18n.t('Spanska'),
  ita: i18n.t('Italienska'),
};

export const SPEAKER_OPTIONS = [
  { label: i18n.t('Automatisk'), value: 0 },
  ...Array.from(Array(10).keys()).map((x) => ({
    label: `${x + 1}`,
    value: x + 1,
  })),
];

export const WORKSPACE_ROLES = [
  { label: i18n.t('Admin'), value: 'admin' },
  { label: i18n.t('Medlem'), value: 'member' },
];

export const PROJECT_ROLES = [
  { label: i18n.t('Admin'), value: 'admin' },
  { label: i18n.t('Redigerare'), value: 'edit' },
  { label: i18n.t('Läsbehörig'), value: 'view' },
];

export const CHART_COLORS = [
  '#2028FA',
  '#B300D7',
  '#EE00AC',
  '#FF0082',
  '#FF005C',
  '#FF4C3B',
  '#FF7F1B',
  '#FFA600',
];

export const ERROR_BREAKPOINT = 40;
export const WARNING_BREAKPOINT = 60;
export const MOBILE_BREAKPOINT = 600;
export const TABLET_BREAKPOINT = 960;

export const SPEAKER_COLORS = [
  '#C41212',
  '#C45212',
  '#C49212',
  '#8AC412',
  '#36C412',
  '#12C499',
  '#1299C4',
  '#1239C4',
  '#5612C4',
  '#B512C4',
  '#9F0F0F',
  '#913D0D',
  '#715409',
  '#425F07',
  '#1A6407',
  '#07644E',
  '#0A607B',
  '#0B2583',
  '#370A7F',
  '#820C8D',
];

export const DOCUMENT_TEMPLATES = [
  { label: i18n.t('Tomt dokument'), value: 'empty', free: true },
  { label: i18n.t('Sammanfattning'), value: 'summary', free: true },
  { label: i18n.t('Intervju'), value: 'interview', free: false },
  { label: i18n.t('Mötesprotokoll'), value: 'meeting', free: false },
];

export const IS_SINGLE_TENENT_MODE =
  process.env.REACT_APP_SINGLE_TENENT_MODE === 'true';
export const HOMEPAGE_URL = process.env.REACT_APP_HOMEPAGE_URL;
export const CALENDAR_RECIPIENT_PREFIX =
  process.env.REACT_APP_CALENDAR_RECIPIENT_PREFIX;
export const CUSTOM_IDP = process.env.REACT_APP_CUSTOM_IDP ? JSON.parse(process.env.REACT_APP_CUSTOM_IDP) : null;

export const LANGUAGE_NAMES = {
  'de': 'Deutsch',
  'en': 'English',
  'no': 'Norsk',
  'sv': 'Svenska',
  'da': 'Dansk',
};
